export enum TypeOfMatchEnum {
    CommonMatch = 0,
    UpperMatch = 1,
    LowerMatch = 2,
    ThirdPlaceMatch = 3,
    FinalMatch = 4,
    RobinRound = 5
}